import * as React from 'react';
import { ReactComponent as MationLogoSvg } from './assets/mation-logo.svg';
const MationLogo = () => {
  return <MationLogoSvg />;
};
export default MationLogo;
